import http from '@/utils/http'

const fetchAll = ({ page, status }) => http()
  .get(`/ratings?page=${page}&status=${status}`)

const accept = ({ id }) => http()
  .post(`/ratings/${id}/accept`)

const reject = ({ id }) => http()
  .post(`/ratings/${id}/reject`)

const save = ({ id, data }) => http()
  .put(`/ratings/${id}`, data)

const canAccept = feedback => !feedback.accepted_at || feedback.rejected_at

const canReject = feedback => !feedback.rejected_at

export default {
  fetchAll,
  accept,
  reject,
  save,
  canAccept,
  canReject
}



// WEBPACK FOOTER //
// ./src/api/feedback.js